<template>
    <div class="relative overflow-hidden referral-container" id="mortgage-calc" :key="mortgageCalcReset">
        <div class="py-6 w-full ">
            <div
                class="
                    max-w-72 mobile-lg:max-w-80 mobile-xl:max-w-lg tablet-sm:max-w-screen-lg laptop-sm:max-w-screen-lg
                    desktop:max-w-screen-xl ultra-wide:max-w-screen-2xl
                    mx-auto w-full flex items-center "
            >
                <div
                    class="
                    w-full tablet-sm:w-auto
                    mx-auto tablet-sm:mx-10 laptop-sm:mx-0
                    px-2 tablet-sm:px-4
                    py-4 tablet-sm:py-8 laptop-sm:py-8
                    relative flex flex-row
                    w-full justify-center items-start bg-white border-double border-secondary-accent border-4
                    z-10 flex-wrap p-12"
                >
                    <!--                    This is cover for when the referral form is opened. -->
                    <Transition
                        enter-active-class="transition-opacity duration-300 ease-out"
                        enter-from-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="transition-opacity duration-300 ease-in"
                        leave-from-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div
                            v-if="showReferralForm"
                            class="absolute inset-0 bg-black bg-opacity-25 z-40 shadow-extra-wide-inset"
                        ></div>
                    </Transition>

                    <div class="w-full tablet-lg:w-1/2 desktop:w-128 flex-grow flex flex-col px-2 laptop-sm:px-4">
                        <form @submit.prevent="" ref="formRef">
                            <div class="w-full tablet-sm:w-auto">
                                <div class="w-full tablet-sm:w-auto">
                                    <MainHead class="text-3xl laptop-sm:text-4xl">Mortgage Calculator</MainHead>
                                    <p class="w-full flex-wrap text-sm laptop-sm:text-base px-2 tablet-sm:px-0 "
                                    >
    <strong>Looking to buy a home?</strong> Share a few details, and I’ll connect you with a trusted mortgage expert
     from my network for a personalized home loan estimate. Whether you're a <strong>first-time homebuyer</strong>, upgrading to
     your next  house, or exploring real estate listings in your ideal neighborhood, I'm here to guide you through
    the <strong>home buying process</strong>. Let’s find out what fits your budget—and use that to match you with the
        right <strong>homes for sale </strong>in your price range.
                                    </p>
                                </div>
                            </div>
                            <div
                                class="grid-cols-1 tablet-sm:grid-cols-9 laptop-sm:grid-cols-2 gap-2 desktop:gap-4 grid mt-4"
                            >
                                <div
                                    class="col-span-1 tablet-sm:col-span-4 laptop-sm:col-span-1 tooltip"
                                    tooltip="The value of the home that you are buying."
                                >
                                    <!-- Form field 1 -->
                                    <Input
                                        name="purchase_price"
                                        :label="'Purchase Price'"
                                        v-model="mortgageForm.purchase_price"
                                        :placeholder="'500,000.00'"
                                        :step="10000"
                                        :type="`price`"
                                        required
                                    />
                                </div>

                                <div
                                    class="col-span-1 tablet-sm:col-span-5 laptop-sm:col-span-1 tooltip"
                                    tooltip="The amount you are able to pay up front for your house."
                                >
                                    <!-- Form field 2 -->
                                    <SplitPercentInput
                                        name="down_payment"
                                        :label="'Down Payment'"
                                        v-model="mortgageForm.down_payment"
                                        :placeholder="'100,000.00'"
                                        :placeholder2="'20'"
                                        :input="mortgageForm.purchase_price"
                                        :step="10000"
                                        :type="`price`"
                                        required
                                    />
                                </div>
                            </div>
                            <div
                                class="grid-cols-1 tablet-sm:grid-cols-9 laptop-sm:grid-cols-2 gap-2 desktop:gap-4 grid mt-1"
                            >
                                <div
                                    class="col-span-1 tablet-sm:col-span-4 laptop-sm:col-span-1 tooltip"
                                    tooltip="The interest rate on your loan, which may be variable over time."
                                >
                                    <!-- Form field 3 -->

                                    <Input
                                        name="vir"
                                        :label="'Interest Rate'"
                                        :step="0.1"
                                        v-model="mortgageForm.vir"
                                        :placeholder="'2'"
                                        :type="`percent`"
                                        required
                                    />
                                </div>
                                <div
                                    class="col-span-1 tablet-sm:col-span-5 laptop-sm:col-span-1 tooltip"
                                    tooltip="The term or length of your loan in years."
                                >
                                    <!-- Form field 4 -->
                                    <Select
                                        name="amortization_period"
                                        :label="'Mortgage Term'"
                                        v-model="mortgageForm.amortization_period"
                                        :type="`number`"
                                        required
                                        :options="mortgageTerms.map((term) => ({ key: term.key, value: term.value }))"
                                        :placeholder="`- Select A Term -`"
                                    />
                                </div>
                            </div>

                            <div
                                class="grid-cols-1 tablet-sm:grid-cols-9 laptop-sm:grid-cols-6 desktop:grid-cols-12 gap-2 desktop:gap-4 grid mt-0 flex items-center mt-1"
                            >
                                <div
                                    class="col-span-1 tablet-sm:col-span-9 laptop-sm:col-span-4 flex items-center justify-start mt-0"
                                >
                                    <h4 class="text-sm laptop-sm:text-lg desktop:text-base mr-2 mt-2 font-subtitle">
                                        For a more detailed result, enter your estimated
                                        <strong><u>annualized</u></strong>
                                        Insurance and Tax Rate.
                                    </h4>
                                </div>
                                <div
                                    class="col-span-1 tablet-sm:col-span-4 laptop-sm:col-span-3 tooltip"
                                    tooltip="Your annual House Insurance costs."
                                >
                                    <!-- Form field 3 -->

                                    <Input
                                        name="insurance"
                                        :label="'Insurance'"
                                        :step="25"
                                        v-model="mortgageForm.insurance"
                                        :placeholder="'0.00'"
                                        :type="`price`"
                                    />
                                </div>
                                <div
                                    class="col-span-1 tablet-sm:col-span-5 laptop-sm:col-span-5 tooltip"
                                    tooltip="Your annual Property Tax costs."
                                >
                                    <!-- Form field 4 -->

                                    <SplitPercentInput
                                        name="tax_rate"
                                        :label="'Property Tax'"
                                        v-model="mortgageForm.tax_rate"
                                        :placeholder="'4,000'"
                                        :placeholder2="'0.8'"
                                        :input="mortgageForm.purchase_price"
                                        :step="100"
                                        :type="`price`"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="w-full tablet-lg:w-1/2 desktop:w-128 flex h-full self-end relative">
                        <div v-show="showReferralButton" class="w-full absolute flex flex-col self-start items-end">
                            <ArrowPathIcon
                                class="w-8 h-8 desktop:w-6 desktop:h-6 mt-32 mr-4 tablet-sm:mt-16 tablet-lg:mt-0
                                tablet-sm:mr-8 tablet-lg:mr-0 cursor-pointer z-50"
                                @click="resetMortgageCalc"
                            />
                        </div>
                        <div
                            class="flex-col-reverse tablet-lg:flex-col w-full flex flex-wrap items-center justify-center"
                        >
                            <div
                                class="flex-grow relative w-full items-center justify-center py-4 tablet-sm:flex hidden"
                                :class="showChart ? '' : ''"
                                ref="chartContainerRef"
                            >
                                <svg ref="chartRef" class="bg-white relative z-0"></svg>
                            </div>
                            <div
                                class="flex-wrap tablet-sm:flex-nowrap tablet-lg:flex-wrap desktop:flex-nowrap flex items-center justify-center w-full gap-x-2"
                            >
                                <button
                                    @click="submitMortgageCalculator"
                                    class="text-base ultra-wide:text-lg ml-0 tablet-lg:ml-6 desktop:ml-6 relative z-20 h-12 mb-2 text-white bg-secondary-bg rounded-xs transition-all duration-300 ease-in-out hover:bg-primary-bg hover:text-primary-text hover:border-accent border-double border-4 border-white"
                                    :class="
                                        showReferralButton
                                            ? 'w-full tablet-sm:w-1/3 tablet-lg:w-full desktop:w-1/3'
                                            : 'w-full tablet-sm:w-1/3 tablet-lg:w-full desktop:w-1/2'
                                        "
                                >
                                    Calculate
                                </button>

                                <button
                                    v-show="showReferralButton"
                                    @click="showFullReport"
                                    class="
                                    hidden tablet-sm:block
                                    text-base ultra-wide:text-lg w-full tablet-sm:w-1/3 tablet-lg:w-full desktop:w-1/3 ml-0 tablet-lg:ml-6 desktop:ml-0 relative z-20 h-12 mb-2 text-primary-text bg-primary-bg transition-all duration-300 ease-in-out hover:bg-primary-bg font-semibold hover:text-secondary-accent hover:border-secondary-accent border-double border-4 border-accent"
                                >
                                    <PrinterIcon class="w-5 h-5 inline-block" />
                                    Print Full Report
                                </button>
                                <div
                                    v-show="showReferralButton"
                                    as="div"
                                    ref="referralButton"
                                    class="w-full tablet-sm:w-1/3 tablet-lg:w-full desktop:w-1/3 ml-0 tablet-lg:ml-6 desktop:ml-0 relative inline-block text-left mb-2 h-12 z-50 relative"
                                >
                                    <button
                                        class="text-base ultra-wide:text-lg w-full h-12 mb-2 text-primary-text bg-accent rounded-xs transition-all duration-300 ease-in-out hover:bg-primary-bg font-semibold hover:text-primary-text hover:border-secondary-accent border-double border-4 border-white"
                                        @click="toggleReferralForm"
                                    >
                                        <BarsArrowUpIcon class="w-5 h-5 inline-block" />
                                        Request a Referral
                                    </button>
                                    <transition
                                        enter-active-class="transition ease-out duration-100"
                                        enter-from-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-from-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95"
                                        @click=""
                                    >
                                        <div
                                            class="w-full desktop:w-128 absolute top-0 right-0 z-50 mt-0 divide-y duration-300 ease-in-out font-semibold bg-accent border-double border-4 border-white"
                                            v-show="showReferralForm"
                                            @click.stop=""
                                        >
                                            <div class="pt-1">
                                                <div>
                                                    <div class="bg-white h-full relative z-50">
                                                        <div
                                                            class="text-right flex items-center justify-center px-1 border-double border-accent border-b border-x-4 bg-accent h-10 z-50"
                                                            @click="toggleReferralForm"
                                                        >
                                                            <p
                                                                href="#"
                                                                class="ultra-wide:text-lg desktop:text-base text-primary-text rounded-xs transition-all duration-300 ease-in-out font-subtitle hover:text-primary-text leading-8 relative"
                                                                :class="[showReferralForm ? '' : '', '']"
                                                            >
                                                                <BarsArrowUpIcon class="w-5 h-5 inline-block" />
                                                                Request a Referral
                                                            </p>
                                                        </div>
                                                        <div class="mx-2 px-2 py-1 mt-4 z-50">
                                                            <p>
                                                                Enter your full name, email, and zip code below below
                                                                and I'll connect you with my broker.
                                                            </p>
                                                            <form @submit.prevent="" ref="referralFormRef">

                                                                <VelocityFormAnimation ref="formAnimation"
                                                                                       :paperTitle="'Mortgage Referral Request'">
                                                                    <div>
                                                                        <Input
                                                                            name="referral_name"
                                                                            :label="'Full Name'"
                                                                            v-model="mortgageForm.referral_name"
                                                                            :placeholder="''"
                                                                            :step="1"
                                                                            :type="`text`"
                                                                            required
                                                                        />
                                                                        <Input
                                                                            name="referral_email"
                                                                            :label="'Email'"
                                                                            v-model="mortgageForm.referral_email"
                                                                            :placeholder="''"
                                                                            :step="1"
                                                                            :type="`text`"
                                                                            required
                                                                        />
                                                                        <Input
                                                                            name="referral_zip"
                                                                            :label="'Zip Code'"
                                                                            v-model="mortgageForm.referral_zip"
                                                                            :placeholder="''"
                                                                            :step="1"
                                                                            :type="`text`"
                                                                            required
                                                                        />
                                                                    </div>
                                                                </VelocityFormAnimation>

                                                            </form>
                                                            <button
                                                                :disabled="isSubmitting"
                                                                class="w-full h-12 mt-2 text-lg text-white bg-secondary-bg rounded-xs my-4 transition-all duration-300 ease-in-out hover:bg-primary-bg hover:text-primary-text border-double border-4 border-white hover:border-accent"
                                                                @click="submitReferralRequest"
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="w-full my-0 overflow-hidden opacity-0 duration-1000 ease-in-out max-h-0"
                        id="monthlyChartData"
                    >
                        <div
                            class="col-span-1 flex flex-col items-start bg-primary-bg mt-0 mobile-lg:mt-1 tablet-sm:mt-2 tablet-lg:mt-4 laptop-sm:mt-6">
                            <div class="bg-primary-bg w-full bg-gradient-to-r from-primary-bg to-white">
                                <div class="bg-white">
                                    <nav class="flex" aria-label="Tabs">
                                        <a
                                            v-for="tab in tabs"
                                            :key="tab.name"
                                            @click.prevent="selectTab(tab)"
                                            class="hidden tablet-sm:block text-center px-3 py-2 text-sm font-medium cursor-pointer rounded-t-lg transition-colors duration-200 ease-in-out bg-primary-bg border-secondary-accent text-primary-text hover:text-primary-text"
                                            :class="
                                                tab.current
                                                    ? 'border border-b-0 '
                                                    : 'border-b border-x border-t hover:underline '
                                            "
                                        >
                                            {{ tab.name }}
                                        </a>
                                        <!--                                        Insert filler that will take up remaining space-->
                                        <div class="flex-grow border-secondary-accent border-b"></div>
                                    </nav>
                                </div>
                            </div>

                            <div class="w-full bg-primary-bg border-secondary-accent border-x border-b pt-4">
                                <transition name="fade-expand" mode="out-in">
                                    <div v-show="currentTab === 'Monthly Costs'">
                                        <div
                                            :key="monthlyChartKey"
                                            id="monthlyChart"
                                            class="mx-1 mobile-lg:mx-4 my-4 tablet-sm:mx-6 tablet-sm:my-6 flex justify-center p-12
                                            rounded-full bg-white border-accent border-double border-4"
                                        >
                                            <div
                                                class="grid-cols-1 tablet-sm:grid-cols-2 tablet-lg:grid-cols-4 w-full grid gap-4 py-2 rounded-lg shadow-md"
                                            >
                                                <div
                                                    class="col-span-1 tablet-sm:col-span-2 tablet-lg:col-span-4 flex flex-col"
                                                >
                                                    <h3
                                                        class="text-center tablet-sm:text-left text-2xl tablet-sm:text-4xl"
                                                    >
                                                        Monthly Cost:
                                                        <span class="tracking-widest">
                                                            &nbsp;
                                                            <span class="text-accent font-bold">$</span>
                                                            {{ monthlyTotal.amountStr }}
                                                        </span>
                                                    </h3>
                                                </div>
                                                <div
                                                    v-for="[key2, item] in Object.entries(mortgageMonthlies)"
                                                    :key="key2"
                                                    class="flex flex-col items-center tracking-widest"
                                                >
                                                    <div
                                                        class="w-full h-2 rounded-full mb-2"
                                                        :style="{ backgroundColor: `${item.color}` }"
                                                    ></div>
                                                    <div class="text-2xl font-semibold">${{ item.amountStr }}</div>
                                                    <div class="text-sm text-gray-600 text-center mt-1">
                                                        {{ item.label }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                                <transition name="fade-expand" mode="out-in">
                                    <div
                                        v-show="currentTab === 'Loan Payment Breakdown'"
                                        class="overflow-hidden w-full"
                                        :key="loanPaymentBreakdownGraphKey"
                                        id="loanPaymentBreakdownGraph"
                                    >
                                        <svg
                                            ref="loanPaymentBreakdownGraphContainerRef"
                                            class="loan-payment-breakdown-graph-container bg-white ml-5"
                                        ></svg>
                                    </div>
                                </transition>

                                <transition name="fade-expand" mode="out-in">
                                    <div
                                        v-show="currentTab === 'Monthly Principle vs Interest'"
                                        class="overflow-hidden"
                                        :key="principleVsInterestGraphKey"
                                        id="principleVsInterestGraph"
                                    >
                                        <svg
                                            ref="principleVsInterestGraphContainerRef"
                                            class="principle-vs-interest-graph-container"
                                        ></svg>
                                    </div>
                                </transition>

                                <transition name="fade-expand" mode="out-in">
                                    <div
                                        v-show="currentTab === 'Monthly Principle vs Interest Tabulated'"
                                        :key="principleVsInterestTabKey"
                                        class="transition-all duration-500 ease-in-out overflow-y-scroll overflow-x-hidden max-h-96"
                                        id="principleVsInterestTab"
                                    >
                                        <div>
                                            <div class="px-8 py-4">
                                                <div class="flow-root">
                                                    <div class="-my-2 overflow-x-auto -mx-6">
                                                        <div class="inline-block w-full py-2 align-middle">
                                                            <table
                                                                ref="principleVsInterestTabContainerRef"
                                                                class="min-w-full divide-y divide-gray divide-x text-center border-gray border-b-2"
                                                            >
                                                                <thead>
                                                                    <tr
                                                                        class="divide-x-2 divide-gray border-gray border-y-2 border-x-2"
                                                                    >
                                                                        <th
                                                                            scope="col"
                                                                            class="py-3.5 pr-3 text-sm font-semibold text-gray-900 pl-0"
                                                                        >
                                                                            Month
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            class="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                                                        >
                                                                            Principal
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            class="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                                                        >
                                                                            Interest
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            class="px-3 py-3.5 text-sm font-semibold text-gray-900"
                                                                        >
                                                                            Balance
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="divide-y divide-gray">
                                                                    <tr
                                                                        class="divide-dashed divide-x divide-gray border-gray border-solid border-x-2"
                                                                    >
                                                                        <td
                                                                            class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900 pl-0"
                                                                        >
                                                                            Example
                                                                        </td>
                                                                        <td
                                                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                                                        >
                                                                            $1000.00
                                                                        </td>
                                                                        <td
                                                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                                                        >
                                                                            $500.00
                                                                        </td>
                                                                        <td
                                                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                                                        >
                                                                            $98500.00
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Input from "@/Components/VelocityForms/Input.vue";
import { defineProps, onMounted, ref } from "vue";
import { pointer, select } from "d3-selection";
import { scaleLinear, scaleOrdinal } from "d3-scale";
import { arc, area, line, pie, stack, stackOffsetNone, stackOrderNone } from "d3-shape";
import { easeElastic, easeLinear } from "d3-ease";
import { interpolate } from "d3-interpolate";
import { useForm, usePage } from "@inertiajs/vue3";
import { max } from "d3-array";
import { axisBottom, axisLeft } from "d3-axis";
import { BarsArrowUpIcon, PrinterIcon, ArrowPathIcon } from "@heroicons/vue/24/solid";
import SplitPercentInput from "@/Components/Forms/SplitPercentInput.vue";
import Select from "@/Components/Forms/Select.vue";
import VelocityFormAnimation from "@/Components/Forms/VelocityFormAnimation.vue";
import { route } from "ziggy-js";
import MainHead from "@/Components/PageContent/MainHead.vue";

import { transition } from "d3-transition";
const chartRef = ref(null);
const chartContainerRef = ref(null);
const loanPaymentBreakdownGraphContainerRef = ref(null); // Ref for D3 graph container
const principleVsInterestGraphContainerRef = ref(null); // Ref for D3 graph container
const principleVsInterestTabContainerRef = ref(null); // Ref for D3 graph container
const showChart = ref(false);
const colors = ["#7CC6FE", "#5DFDCB", "#FFF275", "#C16200"];
const categories = ["principle", "interest", "insurance", "taxes"];
const colorMapping = {
    Principal: "#7CC6FE",
    Interest: "#5DFDCB",
    Insurance: "#FFF275",
    Taxes: "#C16200",
};
const page = usePage();
const monthlyChartKey = ref(0);
const loanPaymentBreakdownGraphKey = ref(0);
const principleVsInterestGraphKey = ref(0);
const principleVsInterestTabKey = ref(0);
const chartWidth = ref(0);
const showReferralButton = ref(false);
const showReferralForm = ref(false);
const referralButton = ref(null);
const referralFormRef = ref(null);
const mortgageCalcReset = ref(0);
const formAnimation = ref(null);
// Reactive state to track if the submission is in progress
const isSubmitting = ref(false);

const mortgageTerms = [
    { key: "15 years", value: 15 },
    { key: "20 years", value: 20 },
    { key: "30 years", value: 30 },
    { key: "40 years", value: 40 },
];

const resetMortgageCalc = () => {
    showReferralButton.value = false;
    showReferralForm.value = false;
    mortgageForm.reset();
    mortgageCalcReset.value += 1;
};

const handleMenuClick = () => {
    // console.log("Menu item clicked, but the menu will remain open.");
};

// showReferralForm
const toggleReferralForm = () => {
    showReferralForm.value = !showReferralForm.value;
};

const props = defineProps({
    errors: {
        type: Object,
        required: false,
    },
});
const total = ref({
    amount: 0,
    amountStr: "",
});
const monthlyTotal = ref({
    amount: 0,
    amountStr: "",
});
const monthlyTotalWOOtherCosts = ref({
    amount: 0,
    amountStr: "",
});
const mortgageTotals = ref({
    Principal: { amount: 200000, amountStr: "200000.00", label: "Principal", color: colors[0] },
    Interest: { amount: 150000, amountStr: "150000.00", label: "Interest", color: colors[1] },
    Insurance: { amount: 25000, amountStr: "25000.00", label: "Insurance (est.)", color: colors[2] },
    Taxes: { amount: 50000, amountStr: "50000.00", label: "Taxes (est.)", color: colors[3] },
});
const mortgageMonthlies = ref({
    Principal: {
        amount: 200000,
        amountStr: "200000.00",
        label: "Principal",
        color: mortgageTotals.value["Principal"].color,
    },
    Interest: {
        amount: 150000,
        amountStr: "150000.00",
        label: "Interest",
        color: mortgageTotals.value["Interest"].color,
    },
    Insurance: {
        amount: 25000,
        amountStr: "25000.00",
        label: "Insurance (est.)",
        color: mortgageTotals.value["Insurance"].color,
    },
    Taxes: {
        amount: 50000,
        amountStr: "50000.00",
        label: "Taxes (est.)",
        color: mortgageTotals.value["Taxes"].color },
});

const data = [
    { name: "Principal", value: 200000 },
    { name: "Interest", value: 150000 },
    { name: "Insurance", value: 25000 },
    { name: "Taxes", value: 50000 },
];
// FORM
const mortgageForm = useForm({
    purchase_price: "",
    down_payment: "",
    vir: "",
    amortization_period: 0,
    insurance: "",
    tax_rate: "",
    referral_name: "",
    referral_email: "",
    referral_zip: "",
});

const formRef = ref(null);

// Associate the formRef with the form object after component mount
onMounted(() => {
    mortgageForm.formRef = formRef;
    // Retrieve form data from sessionStorage
    const savedFormData = sessionStorage.getItem('mortgageFormData');


    if (savedFormData) {
        // Parse the saved data
        const formData = JSON.parse(savedFormData);

        // Assign the saved data to the form object
        Object.assign(mortgageForm, formData);
    }

    //document on click if no clicking on Menu, then close the menu
    document.addEventListener("click", function (event) {
        // check referralButton is set
        if (!referralButton.value) return;

        const isClickInside = referralButton.value.contains(event.target);
        if (!isClickInside) {
            showReferralForm.value = false;
        }
    });
});

// tabbies
const tabs = ref([
    {
        name: "Monthly Costs",
        content: "Content for Tab 1",
        current: true,
        id: "monthlyChart" },
    {
        name: "Loan Payment Breakdown",
        content: "Content for Tab 2",
        current: false,
        id: "loanPaymentBreakdownGraph" },
    {
        name: "Monthly Principle vs Interest",
        content: "Content for Tab 3",
        current: false,
        id: "principleVsInterestGraph",
    },
    {
        name: "Monthly Principle vs Interest Tabulated",
        content: "Content for Tab 4",
        current: false,
        id: "principleVsInterestTab",
    },
]);
const currentTab = ref(tabs.value[0].name);

const selectTab = (selectedTab) => {
    currentTab.value = selectedTab.name;

    tabs.value.forEach((tab) => {
        tab.current = tab.name === selectedTab.name;
    });
};

// This is the same validation as the other form, with the second form added.
function validateReferralForm() {
    // reset errors.
    mortgageForm.errors = {};
    const errors = {};

    if (!validateMortgageCalculator()) {
        // hide form and cover
        showReferralForm.value = false;
    }
    // this loops through all fields in the Inertia form, and checks the required fields in the referralFormRef
    Object.keys(mortgageForm.data()).forEach((field) => {
        const element = referralFormRef.value.querySelector(`#${field}`);
        if (element && element.hasAttribute("required") && !mortgageForm[field].toString().trim()) {
            errors[field] = "This field is required";
        }
    });

    if (Object.keys(errors).length > 0) {
        mortgageForm.setError(errors);
    }
    page.props.errors = mortgageForm.errors;

    return Object.keys(errors).length <= 0;
}

// True if good, false if bad. Updates the fields
function validateMortgageCalculator() {
    // reset errors.
    mortgageForm.errors = {};
    const errors = {};
    // Form Validation, based on the ref. This allows me to frontend validate this section and then add another.
    // Check each field for empty values
    // Check each field specifically
    Object.keys(mortgageForm.data()).forEach((field) => {
        const element = formRef.value.querySelector(`#${field}`);
        if (element && element.hasAttribute("required") && !mortgageForm[field].toString().trim()) {
            errors[field] = "This field is required";
        }
    });

    // Check specific rules
    // Check Down Payment is less than Purchase Price
    if (Number(mortgageForm.down_payment) >= Number(mortgageForm.purchase_price)) {
        errors["down_payment"] = "Down Payment must be less than Purchase Price";
    }

    if (Object.keys(errors).length > 0) {
        mortgageForm.setError(errors);
    }
    page.props.errors = mortgageForm.errors;

    if (Object.keys(errors).length > 0) {
        return false;
    } else {
        return true;
    }
}

function submitMortgageCalculator() {
    // console.log("Mortgage Submission recorded...");
    showChart.value = true;

    // This width is unique compared ot the other charts because its not part of tab.
    // this breakpoint is currently laptop-sm
    const width = window.matchMedia(`(min-width: 1280px)`).matches
        ? 300
        : window.matchMedia(`(min-width: 768px)`).matches
          ? 250
          : 180;
    const height = 300;
    const radius = window.matchMedia(`(min-width: 768px)`).matches ? Math.min(width, height) / 2 : 90;
    const svg = select(chartRef.value);

    const chartElement = document.getElementById("monthlyChartData"); // TODO this doesn't exist?
    chartWidth.value = chartElement.offsetWidth - 20; // for charts

    if (!validateMortgageCalculator()) {
        return; // errors, stop here.
    }

    // Update data
    mortgageTotals.value["Principal"].amount = mortgageForm.purchase_price - mortgageForm.down_payment;
    mortgageTotals.value["Interest"].amount =
        (((mortgageForm.purchase_price - mortgageForm.down_payment) *
            (mortgageForm.vir / 1200) *
            Math.pow(1 + mortgageForm.vir / 1200, mortgageForm.amortization_period * 12)) /
            (Math.pow(1 + mortgageForm.vir / 1200, mortgageForm.amortization_period * 12) - 1)) *
            mortgageForm.amortization_period *
            12 -
        (mortgageForm.purchase_price - mortgageForm.down_payment);
    mortgageTotals.value["Taxes"].amount = mortgageForm.tax_rate * mortgageForm.amortization_period;
    mortgageTotals.value["Insurance"].amount = mortgageForm.insurance * mortgageForm.amortization_period;
    total.value["amount"] =
        mortgageTotals.value["Principal"].amount +
        mortgageTotals.value["Interest"].amount +
        mortgageTotals.value["Insurance"].amount +
        mortgageTotals.value["Taxes"].amount;

    mortgageTotals.value["Principal"].amountStr = mortgageTotals.value["Principal"].amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    mortgageTotals.value["Interest"].amountStr = mortgageTotals.value["Interest"].amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    mortgageTotals.value["Taxes"].amountStr =
        mortgageTotals.value["Taxes"].amount === 0
            ? "-.--"
            : mortgageTotals.value["Taxes"].amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              });
    mortgageTotals.value["Insurance"].amountStr =
        mortgageTotals.value["Insurance"].amount === 0
            ? "-.--"
            : mortgageTotals.value["Insurance"].amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              });
    total.value["amountStr"] = total.value["amount"].toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    mortgageTotals.value = { ...mortgageTotals.value };

    mortgageMonthlies.value["Principal"].amount =
        mortgageTotals.value["Principal"].amount / (mortgageForm.amortization_period * 12);
    mortgageMonthlies.value["Interest"].amount =
        mortgageTotals.value["Interest"].amount / (mortgageForm.amortization_period * 12);
    mortgageMonthlies.value["Taxes"].amount = mortgageForm.tax_rate / 12;
    mortgageMonthlies.value["Insurance"].amount = mortgageForm.insurance / 12;
    monthlyTotal.value["amount"] = total.value["amount"] / (mortgageForm.amortization_period * 12);
    monthlyTotalWOOtherCosts.value["amount"] =
        mortgageMonthlies.value["Principal"].amount + mortgageMonthlies.value["Interest"].amount;

    mortgageMonthlies.value["Principal"].amountStr = mortgageMonthlies.value["Principal"].amount.toLocaleString(
        "en-US",
        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    );
    mortgageMonthlies.value["Interest"].amountStr = mortgageMonthlies.value["Interest"].amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    mortgageMonthlies.value["Taxes"].amountStr =
        mortgageMonthlies.value["Taxes"].amount === 0
            ? "-.--"
            : mortgageMonthlies.value["Taxes"].amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              });
    mortgageMonthlies.value["Insurance"].amountStr =
        mortgageMonthlies.value["Insurance"].amount === 0
            ? "-.--"
            : mortgageMonthlies.value["Insurance"].amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              });
    monthlyTotal.value["amountStr"] = monthlyTotal.value["amount"].toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    monthlyTotalWOOtherCosts.value["amountStr"] = monthlyTotalWOOtherCosts.value["amount"].toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    //transfer to data array
    // matching by name because data must be array for d3 (i think)
    Object.keys(mortgageMonthlies.value).forEach((key) => {
        const item = data.find((d) => d.name === key);
        if (item) item.value = mortgageMonthlies.value[key].amount;
    });
    // matching by name because data must be array for d3 (i think)
    Object.keys(mortgageTotals.value).forEach((key) => {
        const item = data.find((d) => d.name === key);
        if (item) item.value = mortgageMonthlies.value[key].amount;
    });

    // Filter empty if Insurance or Taxes
    const filteredData = data.filter((d) => {
        const value = parseFloat(d.value);
        return (!isNaN(value) && value > 0) || (d.name !== "Taxes" && d.name !== "Insurance");
    });

    // Display
    svg.selectAll("*").remove(); // Clear previous chart if any

    svg.attr("width", width)
        .attr("height", height)
        .style("overflow", "visible") // Allow content to overflow for labels
        .append("g")
        .attr("transform", `translate(${width / 2},${height / 2})`);

    svg.append("g").attr("class", "slices");
    svg.append("g").attr("class", "labels");
    svg.append("g").attr("class", "lines");

    const color = scaleOrdinal()
        .domain(categories)
        .range(colors);
    // console.log("color:", color);

    const pieGenerator = pie()
        .sort(null)
        .value((d) => d.value);

    const innerArc = arc()
        .outerRadius(radius * 0.85)
        .innerRadius(radius * 0.65); // Reduced to make room for labels

    const outerArc = arc()
        .innerRadius(radius * 0.9)
        .outerRadius(radius * 0.9);

    const chart = svg.select("g");

    const arcs = chart.selectAll(".arc").data(pieGenerator(filteredData)).enter().append("g").attr("class", "arc");

    const key = (d) => d.data.name;

    // do some calculations to determine if labels need to be moved, specifically overlapping text labels
    // Precalculate positions and adjust for overlaps
    const labelHeight = 20;
    const labelPadding = 5;
    const pieData = pieGenerator(filteredData);

    const labelPositions = pieData.map((d) => {
        const pos = outerArc.centroid(d);
        const midAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
        pos[0] = radius * 1.02 * (midAngle < Math.PI ? 1 : -1);
        return {
            x: pos[0],
            y: pos[1],
            angle: midAngle,
            name: d.data.name,
            value: d.value,
        };
    });

    // Sort labels by y-position
    labelPositions.sort((a, b) => a.y - b.y);

    // Adjust for overlaps
    for (let i = 1; i < labelPositions.length; i++) {
        const prev = labelPositions[i - 1];
        const curr = labelPositions[i];
        if (curr.y - prev.y < labelHeight + labelPadding) {
            curr.y = prev.y + labelHeight + labelPadding;
        }
    }

    // Create arcs
    arcs.append("path")
        .attr("d", innerArc)
        .attr("fill", (d) => colorMapping[d.data.name])
        .attr("stroke", "white")
        .style("stroke-width", "2px")
        .style("opacity", 0)
        .transition()
        .duration(2500)
        .ease(easeElastic)
        .style("opacity", 1)
        .attrTween("d", function (d) {
            const i = interpolate({ startAngle: 0, endAngle: 0 }, d);
            return function (t) {
                return innerArc(i(t));
            };
        });

    // Add labels
    arcs.append("text")
        .attr("dy", ".5em")
        .attr("transform", (d) => {
            const pos = labelPositions.find((p) => p.name === d.data.name);
            return `translate(${pos.x},${pos.y})`;
        })
        .style("text-anchor", (d) => {
            const pos = labelPositions.find((p) => p.name === d.data.name);
            return pos.angle < Math.PI ? "start" : "end";
        })
        .style("font-size", "14px")
        .style("opacity", 0)
        .each(function (d) {
            const text = select(this);
            text.append("tspan")
                .text((d) => d.data.name)
                .attr("x", 0)
                .attr("dy", 0);
            text.append("tspan")
                .text((d) => d.data.value.toLocaleString("en-US", { style: "currency", currency: "USD" }))
                .attr("x", 0)
                .attr("dy", "1.2em");
        })
        .transition()
        .delay(750)
        .duration(1000)
        .ease(easeLinear)
        .style("opacity", 1);
    // Add polylines
    arcs.append("polyline")
        .attr("points", (d) => {
            const pos = labelPositions.find((p) => p.name === d.data.name);
            const innerPos = innerArc.centroid(d);
            const midAngle = (d.startAngle + d.endAngle) / 2;
            // adjust pos to be slightly closer to mid angle
            pos.x = pos.x * 0.95;

            // Recalculate the midPos based on the new label position
            const midRadius = (radius * 0.8 + radius * 0.7) * .65; // Average of inner and outer radius
            const midX = Math.sin(midAngle) * midRadius;
            const midY = -Math.cos(midAngle) * midRadius;

            // Adjust the midY to be halfway between the inner point and the label
            const adjustedMidY = midY + (pos.y - midY) * .65;

            const midPos = [midX, adjustedMidY];

            return [innerPos, midPos, [pos.x, pos.y]].map((point) => point.join(",")).join(" ");
        })
        .style("fill", "none")
        .style("stroke", "black")
        .style("stroke-width", "2px")
        .style("opacity", 0)
        .transition()
        .delay(750)
        .duration(1000)
        .ease(easeLinear)
        .style("opacity", 1);

    // THIS IS FOR THE CENTER NUMBER
    // Add center text for monthly total
    const centerGroup = svg
        .append("g")
        .attr("text-anchor", "middle")
        .attr("transform", `translate(${width / 2},${height / 2})`);

    const monthlyTotalText = `$${monthlyTotal.value.amountStr}`;

    centerGroup
        .append("text")
        .attr("dy", "-0.5em")
        .style("font-size", "14px")
        .style("fill", "#666")
        .text("Monthly Total");

    const totalText = centerGroup.append("text").attr("dy", "1em").style("font-weight", "bold").text(monthlyTotalText);

    // Function to calculate and set the font size
    function setFontSize(textElement, maxWidth) {
        let fontSize = 20;
        textElement.style("font-size", `${fontSize}px`);

        while (textElement.node().getComputedTextLength() > maxWidth && fontSize > 10) {
            fontSize--;
            textElement.style("font-size", `${fontSize}px`);
        }
    }

    // Calculate the maximum width for the text (80% of the inner circle diameter)
    const maxTextWidth = innerArc.innerRadius()() * 1.6;

    // Set the font size
    setFontSize(totalText, maxTextWidth);

    // Hover effect
    arcs.on("mouseover", function (d) {
        select(this)
            .transition()
            .duration(300)
            .attr(
                "d",
                arc()
                    .innerRadius(radius * 0.4)
                    .outerRadius(radius * 0.75),
            );
    }).on("mouseout", function (d) {
        select(this).transition().duration(300).attr("d", arc);
    });

    const monthlyElement = document.getElementById("monthlyChartData");

    monthlyElement.classList.remove("max-h-0", "opacity-0");
    monthlyElement.classList.add("table-sm:max-h-128", "opacity-100"); // You can adjust max-height based on your content

    // Draw the other graphs
    drawLoanBalanceGraph();
    drawPrincipleVsInterestGraph();
    createPrincipleVsInterestTable();

    // show the referral button
    showReferralButton.value = true;

    // console.log("key returned");
    return [
        monthlyChartKey,
        loanPaymentBreakdownGraphKey,
        principleVsInterestGraphKey,
        principleVsInterestTabKey,
    ];
}

function midAngle(d) {
    return d.startAngle + (d.endAngle - d.startAngle) / 2;
}
// END PIE CHARTING

// START LOAN PAYMENT BREAKDOWN GRAPH
// Draw the LOAN PAYMENT BREAKDOWN Graph
const drawLoanBalanceGraph = () => {
    if (!loanPaymentBreakdownGraphContainerRef.value) {
        console.error("Graph container ref not found");
        return;
    }

    const computeAmortizationData = () => {
        let balance = mortgageForm.purchase_price - mortgageForm.down_payment;
        const monthlyPayment = monthlyTotalWOOtherCosts.value.amount;
        let totalPrincipal = 0;
        let totalInterest = 0;

        return Array.from({ length: mortgageForm.amortization_period * 12 }, (_, i) => {
            const month = i + 1; // Start from month 1

            const interestPayment = balance * (mortgageForm.vir / 1200);
            const principalPayment = monthlyPayment - interestPayment;

            balance -= principalPayment;
            totalPrincipal += principalPayment;
            totalInterest += interestPayment;

            return {
                month,
                principalPaid: totalPrincipal,
                interestPaid: totalInterest,
                remainingBalance: Math.max(balance, 0),
            };
        });
    };

    const amortizationData = computeAmortizationData();

    const svg2 = select(loanPaymentBreakdownGraphContainerRef.value);
    svg2.selectAll("*").remove(); // Clear previous content

    const margin = { top: 20, right: 20, bottom: 30, left: 60 };
    const width = chartWidth.value - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    svg2.attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom);

    const g = svg2.append("g").attr("transform", `translate(${margin.left},${margin.top})`);

    const xScale = scaleLinear()
        .domain([0, mortgageForm.amortization_period * 12 - 1])
        .range([0, width]);

    // Calculate the maximum value across all data points
    const maxValue = max(amortizationData, (d) => Math.max(d.principalPaid, d.interestPaid, d.remainingBalance));

    const yScale = scaleLinear()
        .domain([0, maxValue + 5000])
        .range([height, 0]);

    // Draw X-axis
    g.append("g")
        .attr("transform", `translate(0,${height})`)
        .call(
            axisBottom(xScale)
                .ticks(5)
                .tickFormat((d) => `${d} mo`) // Add 1 to display months starting from 1
                .tickSize(0),
        )
        .call((g) => g.select(".tick:first-of-type").remove());

    // Draw Y-axis
    g.append("g").call(axisLeft(yScale).tickFormat((d) => `$${d / 1000}K`));

    // Create line generators
    const createLine = (accessor) =>
        line()
            .x((d) => xScale(d.month - 1))
            .y(accessor);

    // Draw lines
    const drawLine = (accessor, color) => {
        return g
            .append("path")
            .datum(amortizationData)
            .attr("fill", "none")
            .attr("stroke", color)
            .attr("stroke-width", 2)
            .attr("d", createLine(accessor));
    };

    const principalColor = mortgageTotals.value.Principal.color;
    const interestColor = mortgageTotals.value.Interest.color;
    const remainingColor = "purple";

    const principalLine = drawLine((d) => yScale(d.principalPaid), principalColor);
    const interestLine = drawLine((d) => yScale(d.interestPaid), interestColor);
    const remainingLine = drawLine((d) => yScale(d.remainingBalance), remainingColor);

    // Add hover effect and legend
    const hoverLine = g
        .append("line")
        .attr("y1", 0)
        .attr("y2", height)
        .style("stroke", "#999")
        .style("stroke-dasharray", "3,3")
        .style("opacity", 0);

    const hoverLegend = g.append("g").style("opacity", 0);

    hoverLegend.append("rect").attr("width", 200).attr("height", 125).attr("fill", "white").attr("stroke", "#999");

    const hoverText = hoverLegend.append("text").attr("x", 35).attr("y", 25);

    svg2.append("rect")
        .attr("width", width)
        .attr("height", height)
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .style("fill", "none")
        .style("pointer-events", "all")
        .on("mousemove", function (event) {
            const [x] = pointer(event, this);
            const xValue = Math.round(xScale.invert(x));
            const d = amortizationData[xValue];

            if (d) {
                hoverLine.attr("x1", xScale(xValue)).attr("x2", xScale(xValue)).style("opacity", 1);

                hoverLegend.attr("transform", `translate(${x > width / 2 ? x - 210 : x + 10}, 10)`).style("opacity", 1);

                hoverText
                    .html("")
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "0em")
                    .text(`Month: ${d.month}`)
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "1.7em")
                    .text(
                        `Principal: $${d.principalPaid.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
                    )
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "1.7em")
                    .text(
                        `Interest: $${d.interestPaid.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
                    )
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "1.7em")
                    .text(
                        `Remaining: $${d.remainingBalance.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`,
                    );

                hoverLegend.selectAll(".legend-square").remove();
                hoverLegend
                    .append("rect")
                    .attr("class", "legend-square")
                    .attr("x", 10)
                    .attr("y", 36)
                    .attr("width", 20)
                    .attr("height", 20)
                    .attr("fill", principalColor);
                hoverLegend
                    .append("rect")
                    .attr("class", "legend-square")
                    .attr("x", 10)
                    .attr("y", 64)
                    .attr("width", 20)
                    .attr("height", 20)
                    .attr("fill", interestColor);
                hoverLegend
                    .append("rect")
                    .attr("class", "legend-square")
                    .attr("x", 10)
                    .attr("y", 91)
                    .attr("width", 20)
                    .attr("height", 20)
                    .attr("fill", remainingColor);
            }
        })
        .on("mouseout", function () {
            hoverLine.style("opacity", 0);
            hoverLegend.style("opacity", 0);
        });

    // Add title
    svg2.append("text")
        .attr("x", (width + margin.left + margin.right) / 2)
        .attr("y", 15)
        .attr("text-anchor", "middle")
        .style("font-size", "16px")
        .style("font-weight", "bold")
        .text("Amortization");

    return loanPaymentBreakdownGraphKey;
};

const drawPrincipleVsInterestGraph = () => {
    if (!principleVsInterestGraphContainerRef.value) {
        console.error("Graph container ref not found");
        return;
    }

    const computeMonthlyData = () => {
        let balance = mortgageForm.purchase_price - mortgageForm.down_payment;
        const monthlyPayment = monthlyTotalWOOtherCosts.value.amount;

        return Array.from({ length: mortgageForm.amortization_period * 12 }, (_, i) => {
            const month = i + 1; // Start from month 1
            const interestPayment = balance * (mortgageForm.vir / 1200);
            const principalPayment = monthlyPayment - interestPayment;

            balance -= principalPayment;

            return {
                month,
                principalPayment,
                interestPayment,
            };
        });
    };

    const monthlyData = computeMonthlyData();

    const svg = select(principleVsInterestGraphContainerRef.value);
    svg.selectAll("*").remove(); // Clear previous content

    const margin = { top: 20, right: 20, bottom: 30, left: 60 };
    const width = chartWidth.value - margin.left - margin.right;
    const height = 400 - margin.top - margin.bottom;

    svg.attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom);

    const g = svg.append("g").attr("transform", `translate(${margin.left},${margin.top})`);

    const xScale = scaleLinear()
        .domain([0, mortgageForm.amortization_period * 12])
        .range([0, width]);

    const yScale = scaleLinear().domain([0, monthlyTotal.value.amount]).range([height, 0]);

    // Create stacked data
    const stackGen = stack()
        .keys(["principalPayment", "interestPayment"])
        .order(stackOrderNone)
        .offset(stackOffsetNone);

    const stackedData = stackGen(monthlyData);

    // Create area generator
    const areaGen = area()
        .x((d) => xScale(d.data.month - 1))
        .y0((d) => yScale(d[0]))
        .y1((d) => yScale(d[1]));

    // Draw stacked areas
    const principalColor = mortgageTotals.value.Principal.color;
    const interestColor = mortgageTotals.value.Interest.color;

    g.selectAll("stacked")
        .data(stackedData)
        .enter()
        .append("path")
        .attr("d", areaGen)
        .style("fill", (d, i) => (i === 0 ? principalColor : interestColor));

    // Draw X-axis
    g.append("g")
        .attr("transform", `translate(0,${height})`)
        .call(
            axisBottom(xScale)
                .ticks(5)
                .tickFormat((d) => `${d} mo`) // Add 1 to display months starting from 1
                .tickSize(0),
        )
        .call((g) => g.select(".tick:first-of-type").remove());

    // Draw Y-axis
    g.append("g").call(axisLeft(yScale).tickFormat((d) => `$${d.toLocaleString()}`));

    // Add hover effect and legend
    const hoverLine = g
        .append("line")
        .attr("y1", 0)
        .attr("y2", height)
        .style("stroke", "#999")
        .style("stroke-dasharray", "3,3")
        .style("opacity", 0);

    const hoverLegend = g.append("g").style("opacity", 0);

    hoverLegend.append("rect").attr("width", 200).attr("height", 90).attr("fill", "white").attr("stroke", "#999");

    const hoverText = hoverLegend.append("text").attr("x", 35).attr("y", 25);

    svg.append("rect")
        .attr("width", width)
        .attr("height", height)
        .attr("transform", `translate(${margin.left},${margin.top})`)
        .style("fill", "none")
        .style("pointer-events", "all")
        .on("mousemove", function (event) {
            const [x] = pointer(event, this);
            const xValue = Math.round(xScale.invert(x));
            const d = monthlyData[xValue];

            if (d) {
                hoverLine.attr("x1", xScale(xValue)).attr("x2", xScale(xValue)).style("opacity", 1);

                hoverLegend.attr("transform", `translate(${x > width / 2 ? x - 210 : x + 10}, 10)`).style("opacity", 1);

                hoverText
                    .html("")
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "0em")
                    .text(`Month: ${d.month}`)
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "1.7em")
                    .text(
                        `Principal: $${d.principalPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                    )
                    .append("tspan")
                    .attr("x", 35)
                    .attr("dy", "1.7em")
                    .text(
                        `Interest: $${d.interestPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                    );

                hoverLegend.selectAll(".legend-square").remove();
                hoverLegend
                    .append("rect")
                    .attr("class", "legend-square")
                    .attr("x", 10)
                    .attr("y", 36)
                    .attr("width", 20)
                    .attr("height", 20)
                    .attr("fill", principalColor);
                hoverLegend
                    .append("rect")
                    .attr("class", "legend-square")
                    .attr("x", 10)
                    .attr("y", 64)
                    .attr("width", 20)
                    .attr("height", 20)
                    .attr("fill", interestColor);
            }
        })
        .on("mouseout", function () {
            hoverLine.style("opacity", 0);
            hoverLegend.style("opacity", 0);
        });

    // Add title
    svg.append("text")
        .attr("x", (width + margin.left + margin.right) / 2)
        .attr("y", 15)
        .attr("text-anchor", "middle")
        .style("font-size", "16px")
        .style("font-weight", "bold")
        .text("Monthly Principal vs Interest");

    return principleVsInterestGraphKey;
};

const createPrincipleVsInterestTable = () => {
    if (!principleVsInterestTabContainerRef.value) {
        console.error("Table container ref not found");
        return;
    }

    const computeMonthlyData = () => {
        let balance = mortgageForm.purchase_price - mortgageForm.down_payment;
        const monthlyPayment = monthlyTotalWOOtherCosts.value.amount;

        return Array.from({ length: mortgageForm.amortization_period * 12 }, (_, i) => {
            const month = i + 1;
            const interestPayment = balance * (mortgageForm.vir / 1200);
            const principalPayment = monthlyPayment - interestPayment;

            balance -= principalPayment;

            return {
                month,
                principalPayment,
                interestPayment,
                balance,
            };
        });
    };

    const monthlyData = computeMonthlyData();

    // Get the table body
    const tableBody = principleVsInterestTabContainerRef.value.querySelector("tbody");

    // Clear all existing rows
    tableBody.innerHTML = "";

    // Create and append new rows
    monthlyData.forEach((data) => {
        const row = tableBody.insertRow();
        row.innerHTML = `
            <td class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900 pl-0">${data.month}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">$${data.principalPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">$${data.interestPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">$${data.balance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
        `;
        // add classes to row
        row.classList.add("divide-x", "divide-gray", "divide-dashed", "border-solid", "border-gray", "border-x-2");
    });

    return principleVsInterestTabKey;
};


const submitReferralRequest = async (e) => {
    isSubmitting.value = true; // Disable the button
    e.preventDefault();
    // Frontend validation of the form.
    if (!validateReferralForm()) {
        return;
    }

    let formKey = 'mortgage_referral';
    let redirectKey = "/mortgage-calculator";
    // Collect the submission data in a json string for insertion into submission table
    const jsonData = JSON.stringify(mortgageForm.data());

    const velocitySubmissionForm = useForm({
        form_key: formKey,
        field_values: jsonData,
        redirect: redirectKey,
        recaptcha_token: ""
    });

    try {
        // Execute reCAPTCHA
        velocitySubmissionForm.recaptcha_token  = await grecaptcha.enterprise.execute('6LeDhtAqAAAAAJm-0AUDswv8xmB2K8knAmdzyDHi', { action: 'SUBMIT' });
    } catch (error) {
        console.error('reCAPTCHA error:', error);
    }

    velocitySubmissionForm.post( route('velocitySubmission.submitPublic', formKey ),{
        preserveState: true,
        preserveScroll: true,

        onError: (errors) => {
            // Log the detailed error object to the console for debugging
            console.error('Error Details:', errors);

            // Construct a detailed error message if the errors object contains specific error messages
            let detailedErrorMessage = 'There was an error submitting the form "' + page.props.velocityForm.title +
                '".';
            if (errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
                // Append each error message to the detailed error message
                Object.keys(errors).forEach((key) => {
                    detailedErrorMessage += ` ${key}: ${errors[key]}`;
                });
            }
            formAnimation.value.toggleOnEnvelopeFailAnimation(detailedErrorMessage);

            // Display the detailed error message in the UI
            page.props.messages.push({
                message: detailedErrorMessage,
                duration: 10,
                type: "error"
            });
            // console.log(detailedErrorMessage);
        },
        onSuccess: () => {
            formAnimation.value.toggleOnEnvelopeSentAnimation();
            setTimeout(() => {
                resetMortgageCalc();
                isSubmitting.value = false; // Disable the button
            }, 7500)
        },
    });
}

const showFullReport = () => {
    // Save form data to sessionStorage
    sessionStorage.setItem('mortgageFormData', JSON.stringify(mortgageForm));
    const savedFormData = sessionStorage.getItem('mortgageFormData');
    mortgageForm.post(route('mortgage-calculator.full-report'), {
        onSuccess: () => {
            console.log('Form submitted successfully!');
        },
        onError: (errors) => {
            console.error('Form submission failed:', errors);
        },
    });
}
</script>
